var _path, _path2, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Alert_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 4,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1c.8 0 1.423.696 1.334 1.49l-.779 7.013A.559.559 0 0 1 8 10",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1c.8 0 1.423.696 1.334 1.49l-.779 7.013a.559.559 0 0 1-1.11 0l-.78-7.012A1.343 1.343 0 0 1 8 1Z",
    fill: "#C4C4C4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 13.5,
    r: 1.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Alert_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14161A",
    d: "M0 0h16v16H0z"
  }))));
};
export { SvgAlert as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzI5ODFfNjU4MjAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjYiIHk9IjEiIHdpZHRoPSI0IiBoZWlnaHQ9IjE0Ij4KPHBhdGggZD0iTTggMUM4LjgwMDE4IDEgOS40MjI3MiAxLjY5NTU0IDkuMzM0MzUgMi40OTA4M0w4LjU1NTIyIDkuNTAzMDZDOC41MjM3OCA5Ljc4NTk3IDguMjg0NjUgMTAgOCAxMCIgZmlsbD0iI0M0QzRDNCIvPgo8cGF0aCBkPSJNOCAxQzguODAwMTggMSA5LjQyMjcyIDEuNjk1NTQgOS4zMzQzNSAyLjQ5MDgzTDguNTU1MjIgOS41MDMwNkM4LjUyMzc4IDkuNzg1OTcgOC4yODQ2NSAxMCA4IDEwQzcuNzE1MzUgMTAgNy40NzYyMiA5Ljc4NTk3IDcuNDQ0NzggOS41MDMwNkw2LjY2NTY1IDIuNDkwODNDNi41NzcyOCAxLjY5NTU0IDcuMTk5ODIgMSA4IDFaIiBmaWxsPSIjQzRDNEM0Ii8+CjxjaXJjbGUgY3g9IjgiIGN5PSIxMy40OTk5IiByPSIxLjUiIGZpbGw9IiNDNEM0QzQiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzI5ODFfNjU4MjApIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSIjMTQxNjFBIi8+CjwvZz4KPC9zdmc+Cg==";